module.exports = __webpack_public_path__ + "static/img/12.309e404.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/zh/12.png
// module id = rieV
// module chunks = 0